import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import FontAweasome from 'react-fontawesome'
import moment from 'moment'
import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import BoxButton from '../Layout/BoxButton'

import { 
    displayModalSelectVersion,
    updateInputs,
    activateVersion
} from '../../actions/tiquetesaereo'


class ModalSelectVersion extends Component {

	handleCloseModal = (e) => {
		const modal = document.getElementById('modalSelectVersion')
		modal.classList.remove('fadeIn')
		modal.classList.add('fadeOut')

		const modalDialog = document.querySelector(`#modalSelectVersion .modal-dialog`)
		modalDialog.classList.remove('zoomIn')
		modalDialog.classList.add('zoomOut')

		setTimeout(() => this.props.displayModalSelectVersion(false, '', ''), 300)
    }
    


	render() {

        const { modalSelectVersion } = this.props


		if (!modalSelectVersion.get('show')) {
			return null
        }
        

		return(
			<Modal id="modalSelectVersion" show={ true } ZIndex={ 2000 } width={ 1024 } >
				<form id="form" onSubmit={ e => { e.preventDefault(); this.props.addOrEditCotizacion() }} noValidate>
					<ModalHeader title={ modalSelectVersion.get('title') } onClose={ (e) => this.handleCloseModal(e) } />
					<ModalBody>
                        <table className="table table-condensed table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>Versión</th>
                                    <th>Fecha solitud</th>
                                    <th style={{"width": "12%"}}>Tipo de viaje</th>
                                    <th style={{"width": "11%"}}>Tipo de trayectoria</th>
                                    <th style={{"width": "9%"}}>Cantidad de pasajeros</th>
                                    <th style={{"width": "6%"}}>Asistencia al viajero</th>
                                    <th>Origen</th>
                                    <th>Fecha salida</th>
                                    <th>Destino</th>
                                    <th>Fecha llegada</th>
                                    <th style={{"width": "10%"}}>Centro de costo</th>
                                    <th style={{"width": "10%"}}>Autor</th>
                                </tr>
                            </thead>
                            <tbody>
                                {modalSelectVersion.get('data') && modalSelectVersion.get('data').map((row, index) => {
                                    return (
                                        <tr key={`tr[${row.get('id')}]`} className={row.get('activo') ? 'success': ''}>
                                            <td style={{"textAlign": "right"}}>
                                                {!row.get('activo') ? <span className='LinkToEdit' onClick={() => this.props.activateVersion(row.get('id'))}>
                                                    {modalSelectVersion.get('data').count() - index}
                                                </span> :
                                                <span>{modalSelectVersion.get('data').count() - index}</span>}
                                            </td>
                                            <td>{moment(row.get('created_at')).format('YYYY-MM-DD')}</td>
                                            <td>
                                                {row.get('tipo_viaje') && <select className="form-control input-sm" value={row.get('tipo_viaje') || ''} disabled>
                                                    <option value="1">Nacional</option>
                                                    <option value="2">Internacional</option>
                                                </select>}
                                            </td>
                                            <td>
                                                {row.get('tipo_trayecto') && <select className="form-control input-sm" value={row.get('tipo_trayecto') || ''} disabled>
                                                    <option value="1">Ida y vuelta</option>
                                                    <option value="2">Solo ida</option>
                                                    <option value="3">Multiples ciudades</option>
                                                </select>}
                                            </td>
                                            <td style={{"textAlign": "right"}}>{row.get('cant_pasajeros') || ''}</td>
                                            <td style={{"textAlign": "center"}}>{row.get('asistencia_viajero') ? <FontAweasome name="check-square" />: ""}</td>
                                            <td>{row.get('trayectos').count() && row.getIn(['trayectos', 0, 'origen'])}</td>
                                            <td>{row.get('trayectos').count() && moment(row.getIn(['trayectos', 0, 'fecha_ida'])).format('YYYY-MM-DD HH:mm:ss')}</td>
                                            <td>{row.get('trayectos').count() && row.getIn(['trayectos', 0, 'destino'])}</td>
                                            <td>{row.get('trayectos').count() && moment(row.getIn(['trayectos', 0, 'fecha_destino'])).format('YYYY-MM-DD HH:mm:ss')}</td>
                                            <td>{row.get('cencos').count() && row.getIn(['cencos', 0, 'descripcion'])}</td>
                                            <td>{row.get('usuario') && `${row.getIn(['usuario', 'nombres'])} ${row.getIn(['usuario', 'apellidos'])}`}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
					</ModalBody >
					<ModalFooter >
					</ModalFooter>
				</form>
			</Modal>
		)
	}
}

const mapStateToProps = (state) => {
	return {
        modalSelectVersion: state.tiquetesaereo.get('modalSelectVersion'),
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
        displayModalSelectVersion: (show, title, mode) => dispatch(displayModalSelectVersion(show, title, mode)), 
        updateInputs: (path, value) => dispatch(updateInputs(path, value)), 
        activateVersion: (viaje_id) => dispatch(activateVersion(viaje_id)), 
	}
}




export default connect(mapStateToProps, mapDispatchToProps)(ModalSelectVersion)



// WEBPACK FOOTER //
// ./src/components/TiquetesAereos/ModalSelectVersion.jsx